import { collection, doc, setDoc, getDocs, query, where, orderBy, limit, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebase";

// Servicio de actividad de usuario
export const activityService = {
    // async getRecentActivity(userId) { ... }
    async createTransaction(transactionData) {
        const transactionRef = doc(collection(db, "transactions"));
        await setDoc(transactionRef, {
            ...transactionData,
            status: "completed",
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
        });
        return transactionRef.id;
    },
    async getUserTransactions(userId) {
        const transactionsRef = collection(db, "transactions");
        const q = query(
            transactionsRef,
            where("userId", "==", userId),
            orderBy("createdAt", "desc"),
            limit(10)
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    }
}; 